import { render, staticRenderFns } from "./PelletsConsumption.vue?vue&type=template&id=2e4e898c&scoped=true"
import script from "./PelletsConsumption.vue?vue&type=script&lang=ts"
export * from "./PelletsConsumption.vue?vue&type=script&lang=ts"
import style0 from "./PelletsConsumption.vue?vue&type=style&index=0&id=2e4e898c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e898c",
  null
  
)

export default component.exports